﻿import { ComponentType } from './DoorFrontInteraction.js';
import { MultiStepProductEditor } from './MultiStepProductEditor.js';

export class MultiStepDoorFrontEditor extends MultiStepProductEditor {
  /**
   * Is called when (after) a product is displayed, and whenever the screen is resized sufficiently.
   */
  refreshCurrentScreen(nextStep, initializeEditScope) {
    super.refreshCurrentScreen(nextStep, initializeEditScope);

    if (this.componentType === ComponentType.panel) {
      // No need to display the "One panel at a time" button if all doors have single panel only
      const onePanelAtATimeBtn = this.currentScreen.editScopeBtnGroup &&
        this.currentScreen.editScopeBtnGroup.querySelector('.btn[data-edit-scope="panel"]');
      if (onePanelAtATimeBtn) {
        const front = this.drawing.product;
        const allDoorsHaveSinglePanel = front.allDoorsHaveSinglePanel && front.allDoorsHaveSinglePanel();
        onePanelAtATimeBtn.classList.toggle('d-none', allDoorsHaveSinglePanel);
      }
    }
  }
}
